<igo-spatial-filter-type
  [store]="spatialListStore"
  [selectedQueryType]="queryType"
  [layers]="activeLayers"
  (eventType)="getOutputType($event)"
  (eventQueryType)="getOutputQueryType($event)"
  (zonesWithBufferChange)="onAddZoneWithBuffer($event)"
  (bufferChange)="buffer = $event"
  (measureUnitChange)="measureUnit = $event"
  [zones]="zones"
  (addZone)="onAddZone($event)"
  (removeZone)="onRemovedZone($event)"
/>

<igo-spatial-filter-item
  [type]="type()"
  [queryType]="queryType"
  [map]="map"
  [zones]="zones"
  [loading]="loading"
  [store]="store"
  [layers]="activeLayers"
  [allLayers]="layers"
  [thematicLength]="thematicLength"
  (radiusEvent)="buffer = $event"
  (bufferEvent)="buffer = $event"
  (measureUnitChange)="measureUnit = $event"
  (freehandControl)="freehandDrawIsActive.set($event)"
  (drawZoneEvent)="this.zones = [$event]"
  (zonesWithBufferChange)="onAddZoneWithBuffer($event)"
  (itemTypeChange)="itemType.set($event)"
  (thematicChange)="thematics = $event"
  (toggleSearch)="getOutputToggleSearch()"
  (clearButtonEvent)="clearMap()"
  (clearSearchEvent)="getOutputClearSearch()"
  (export)="activateExportTool()"
  (openWorkspace)="activateWorkspace()"
  (entityChange)="activateWorkspace($event)"
/>
@if (selectedFeature$ | async; as feature) {
  <igo-feature-details [feature]="feature" />
}
